module.exports = __webpack_public_path__ + "static/adac-058f3f0f25e1382fc3dd94aa4510042d.png";